import { render, staticRenderFns } from "./cluetips.vue?vue&type=template&id=8085976a&"
import script from "./cluetips.vue?vue&type=script&lang=js&"
export * from "./cluetips.vue?vue&type=script&lang=js&"
import style0 from "./cluetips.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports